module.exports = __webpack_public_path__ + "img/5.2d9c2d68.png";